<script>
import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(SplitText)

export default {
  name: "TakeaBreakOutro",
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    isMap: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isMap(newVal) {
      if (newVal === true) {
        this.$nextTick(() => {
          this.getAvatar(this.formData.avatar);
        });
      }
    },
  },
  data() {
    return {
      selectedImage: null
    }
  },
  beforeMount() {
    this.$emit('goBack', 1);
  },
  mounted() {
    this.initAnimation();
  },
  methods: {
    getAvatar(avatar) {
      this.selectedImage = require(`@/assets/img/avatare/${avatar}.webp`);
    },
    launchTimeStep1() {
      this.$emit('nextStep', 'launchTimeStep1');
    },
    eventStep1() {
      this.$emit('nextStep', 'eventStep1');
    },
    closeOverlay() {
      this.$emit('closeOverlay');
    },
    resetPopup() {
      this.$emit('nextStep', 0);
    },
    initAnimation() {

      var mySplitText = new SplitText(this.$refs.speechbubble_anim.children, {type: "words"});
      var splitTextTimeline = gsap.timeline();
      mySplitText.split({type: "chars, words"})
      splitTextTimeline
          .from(this.$refs.popupHeroContainer, {
            x:-50,
            autoAlpha:0,
          })
          .from(this.$refs.introcontent, {
            x:50,
            autoAlpha:0,
          })
          .from(mySplitText.chars, {
            duration: 0.6,
            // display:"none",
            visibility: "hidden",
            stagger: 0.016
          })
          .fromTo(this.$refs.button1, {
            y: 20,
            autoAlpha: 0
          }, {
            y: 0,
            autoAlpha: 1
          })
          .fromTo(this.$refs.button2, {
            y: 20,
            autoAlpha: 0
          }, {
            y: 0,
            autoAlpha: 1
          });


    },
  }
}
</script>

<template>


  <div ref="smallPopup" id="sidebarpopup" class="popup overlay smallerpopup"
       data-model="">
    <div ref="popup_wrapper__smaller" class="popup_wrapper popup_wrapper__smaller">
               <span @click="closeOverlay" class="popup_closepopup closeoverlay">
<svg xmlns="http://www.w3.org/2000/svg" width="22.945" height="22.945" viewBox="0 0 22.945 22.945">
  <g id="Gruppe_7895" data-name="Gruppe 7895" transform="translate(1.414 1.414)">
    <line id="Linie_4" data-name="Linie 4" x2="20.117" y2="20.117" transform="translate(0 0)" fill="none" stroke="#fff"
          stroke-linecap="round" stroke-width="2"/>
    <line id="Linie_5" data-name="Linie 5" x2="20.117" y2="20.117" transform="translate(20.117 0) rotate(90)"
          fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
  </g>
</svg>
</span>
      <div class="popup_content popup_content_right">
        <div style="display: flex; gap:10px; align-items: stretch;">
          <div ref="popupHeroContainer" class="herocontainer">
            <img src="@/assets/img/mann_ohneschatten_small.webp">
            <img src="@/assets/img/frau_ohneschatten_small.webp">
          </div>
          <div ref="popup_content_right_container" class="popup_content_right_container">
            <div ref="introcontent" class="form-content introcontent"
                 style="translate: none; rotate: none; scale: none; transform: translate(0px, 0px); opacity: 1; visibility: inherit;">
              <div class="herowrapper">
                <img src="@/assets/img/female.png"/>
                <img src="@/assets/img/male.png"/>
              </div>
              <div ref="speechbubble_anim">
                <p class="speechbubble_anim">{{ $t("takeaBreak.breakFinish_line1")}}</p>
                <p class="speechbubble_anim">{{ $t("takeaBreak.breakFinish_line2")}}</p>
              </div>
            </div>
            <div ref="button1">
            <a @click="closeOverlay"  class="button nextstep getGuideStep"
               href="#"><span>{{ $t("takeaBreak.breakFinish_label1")}}</span><img
                src="@/assets/img/arrow-right.svg"></a>
            </div>
            <div ref="button2">
            <a @click="resetPopup"  class="button nextstep takeabreakStep outline"
               href="#"><img style="transform:scaleX(-1);"
                             src="@/assets/img/arrow-right.svg"><span>{{ $t("takeaBreak.breakFinish_label2")}}</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style lang="scss" scoped>
.popup_wrapper__smaller {
  padding: 125px 125px 20px 50px !important;

  @media screen and (max-width:768px) {
    padding: 125px 125px 50px 50px !important;
  }
}

.herocontainer {
  img {
    width:400px !important;
  }
}

.popup_wrapper__smaller {
  padding: 125px 125px 20px 50px !important;
  @media screen and (max-width:768px) {
    padding: 125px 125px 50px 50px !important;
  }
  @media screen and (max-width:640px) {
    padding: 125px 15px 50px !important;
    flex-direction: column-reverse !important;
  }
  @media screen and (max-width:480px) {
    padding: 95px 15px 50px !important;
    flex-direction: column-reverse !important;
  }
}

.herowrapper {
  display:none;
  @media screen and (max-width:480px) {
    position: absolute;
    display:flex;
    top: 0px;
    transform: translateY(-85%);
    left: 0px;
  }
}

.herocontainer {
  img {
    width: 400px !important;
    @media screen and (max-width: 1024px) {
      width: 250px !important;
    }
  }
  @media screen and (max-width:480px) {
    display:none;
  }
}

.popup_morecontrols {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  left: 35px;
  top: 35px;
  box-sizing: border-box;
  z-index: 2;
  gap: 60px;
  font-size: 18px;

  @media screen and (max-width:768px) {
    gap:30px;
    font-size:16px;
    position:relative;
    margin-top:25px;
    top: auto;
    left: auto;
  }

  .flex-wrapper {
    position:relative;
    svg {
      position:absolute;
      top:0px;
      right:0px;
      transform:translateY(-25%) translateX(5px);
      height:auto;
      padding: 2px;
      background: #015672;
      stroke: white;
      border-radius: 50%;
      width: 20px;
      box-sizing: border-box;
    }
  }

  > div {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor:pointer;
    transition:0.3s;
    &:hover {
      transform:scale(1.1);
    }
    svg {

    }
  }

  img {
    width: 40px;
    height: auto;
    border: 2px solid #015672;
    border-radius: 50%;
  }

}


.popup_content_right {
  @media screen and (max-width:640px) {
    width:100%;
    > div {
      width:100%;
    }
  }
}
.popup_content_right_container {
  @media screen and (max-width:640px) {
    width:100%;
  }
}
</style>
